export default __webpack_public_path__ + "static/media/download.f5e6cfb8.svg";